import useBootstrapData from './useBootstrapData'

export default function useCityNameInFormHeadlineForSEMFlights() {
  const { prePopData } = useBootstrapData()
  const cityName = prePopData?.flights?.flights?.[0]?.endLocation?.cityName

  return cityName ? `Fly to ${cityName} with confidence` : ''
}
